module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "engineerManage"
    }
  }, [_c('div', {
    staticClass: "Engineer container"
  }, [_c('span', {
    staticClass: "headerSpan",
    staticStyle: {
      "padding-bottom": "10px",
      "display": "block"
    }
  }, [_vm._v("背包类型")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.EngineerLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "EngineerListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectEngineer(item, index)
        }
      }
    }, [_c('span', {
      class: {
        active: _vm.activeIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), (_vm.basicsAuth.engineerGreadeEdit) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitEngineer(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('em', {
      class: {
        disabledColor: item.status == -1
      }
    }, [_vm._v(_vm._s(item.gradeName))])])
  }), _vm._v(" "), (_vm.basicsAuth.engineerGreadeAdd) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newEngineer()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogEngineer,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogEngineer = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('EngineerForm')
      }
    }
  }, [_c('el-form', {
    ref: "EngineerForm",
    attrs: {
      "model": _vm.EngineerForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition,
      "rules": _vm.EngineerFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "等级名称：",
      "prop": "gradeName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入等级名称(不超过20个字)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.EngineerForm.gradeName),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "gradeName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.gradeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "status"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.EngineerForm.status),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "status", $$v)
      },
      expression: "EngineerForm.status"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update' && _vm.basicsAuth.engineerGreadeEditFs) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('EngineerForm')
      }
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.dialogMenuStatus == 'update' && _vm.basicsAuth.engineerGreadeEditFs) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('EngineerForm')
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('EngineerForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container-part2"
  }, [_c('el-col', [_c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("品牌")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, _vm._l((_vm.brandLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeBrandIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectBrand(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.brandName))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("品类")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, _vm._l((_vm.categoryLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeCategoryIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "headerSpan"
  }, [_vm._v("型号")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, _vm._l((_vm.modelLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl listPart",
      class: {
        active: _vm.activeModelIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectModel(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 0)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "container containerTable"
  }, [_c('p', [_vm._v("选择擅长故障")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exitMater()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.exitHtml) + "\n        ")]), _vm._v(" "), _c('el-form', {
    ref: "begoodForm",
    attrs: {
      "model": _vm.begoodForm,
      "label-width": "80px"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, _vm._l((_vm.faultLists), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "disabled": _vm.allowExit,
        "label": item.faultSubclassId
      }
    }, [_vm._v(" " + _vm._s(item.faultSubclassName))])
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-1a791835","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/engineerManage.vue
// module id = 1595
// module chunks = 0